import { Separator } from '@/modules/ui/components/separator/Separator';
import { Skeleton } from '@/modules/ui/components/skeleton/Skeleton';

export function ShortlistCandidateCardSkeleton() {
  return (
    <div className="bg-card rounded-xl border">
      <div className="flex flex-col gap-1.5 px-4 py-3 md:px-8 md:py-5">
        <div className="flex items-center gap-2">
          <Skeleton className="h-5 w-44 md:h-6" />
          <Skeleton className="size-4 shrink-0 rounded-sm" />
        </div>
        <Skeleton className="h-4 w-72 max-w-full" />
      </div>

      <Separator />

      <div className="px-4 py-4 md:px-8 md:py-6">
        <div className="flex flex-col gap-6 md:flex-row md:gap-8">
          <div className="flex-1 space-y-4">
            {Array.from({ length: 4 }).map((_, index) => (
              <Skeleton
                key={`experience-${index}`}
                className="h-4 w-full max-w-sm"
              />
            ))}
          </div>

          <div className="bg-border hidden w-px self-stretch md:block" />

          <div className="flex flex-1 flex-wrap gap-2">
            {Array.from({ length: 3 }).map((_, index) => (
              <Skeleton
                key={`strength-${index}`}
                className="h-7 w-28 rounded-full"
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
